export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_amzFtyOutboundNo') || '出库发货单号',
    field: 'amzFtyOutboundNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amzFtyNoticeOutNo') || '出库通知单号',
    field: 'amzFtyNoticeOutNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amazonStoreRegion') || '店铺区域',
    field: 'v_amazonStoreRegion',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shipPlanType') || '发运计划类型',
    field: 'v_shipPlanType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'amzFtyOutboundStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_shipmentByFactory') || '是否工厂发货',
    field: 'v_shipmentByFactory',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ecomWarehouse') || '出库仓库',
    field: 'ecomWarehouseName',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) =>
      cellValue || that.$l('table_label_ecomWarehouse_default') || '工厂仓库',
  },
  {
    title: that.$l('table_label_bookContractNo') || '外运单号',
    field: 'bookContractNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '订单客户',
    field: 'custName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_endCust') || '终端客户',
    field: 'endCustName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDate') || '预计进仓日期',
    field: 'deliveryDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_comfirmDeliveryDate') || '确认送仓日期',
    field: 'comfirmDeliveryDate',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '供应商',
    field: 'scmName',
    width: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_buyer') || '跟单业务',
    field: 'buyerName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_totalCtnQty') || '总箱数',
    field: 'totalCtnQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalGoodsQty') || '产品总数',
    field: 'totalGoodsQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '总入库金额',
    field: 'totalAmount',
    width: 120,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
